import React from 'react'

const TextInputWrapper = React.forwardRef((props, ref) => (
  <div className='row'>
    <div className='col-sm-12'>
      <label className='pn-text-input-label'>
        <span>{props.label}</span>
        <input className='form-control' {...props} ref={ref} />
        {props.error && <div className='error_container'>{props.error}</div>}
      </label>
    </div>
  </div>
))

export default TextInputWrapper
